/* ===========================================================================
   FRAMESI · OLA ANTES DEL BUEN FIN · grupo T4 (portada, colecciones, búsqueda, anuncios)

   Una sola cosa: la franja de la promoción vigente (snippets/fx-ola-franja.liquid)
   elige sola qué promoción se ve, según la fecha en la Ciudad de México.

     hasta el 12-nov     fase a · FRAMESI20 (20 % desde $799)
     del 13 al 17-nov    fase b · Buen Fin, «Ahorro Framesi» (20 % y 25 %)
     desde el 18-nov     fase c · apagada [FALTA: promoción desde el 18-nov, decide Alexis]

   Para probar otra fecha: ?fx_fecha=AAAA-MM-DD. Solo se atiende en un tema sin
   publicar (Shopify.theme.role distinto de «main»): en la tienda en vivo se ignora.

   Guarda de inicialización única: el snippet puede cargarse desde más de una sección.
   ======================================================================== */
(function () {
  'use strict';
  if (window.__fxOlaPortada) return;
  window.__fxOlaPortada = true;

  var FIN_A = '2026-11-12';   // último día de FRAMESI20
  var FIN_B = '2026-11-17';   // último día del Buen Fin

  function hoyMexico() {
    // 1) fecha forzada, solo en un tema sin publicar
    try {
      var forzada = new URLSearchParams(window.location.search).get('fx_fecha');
      var rol = window.Shopify && window.Shopify.theme && window.Shopify.theme.role;
      if (forzada && /^\d{4}-\d{2}-\d{2}$/.test(forzada) && rol && rol !== 'main') return forzada;
    } catch (e) { /* sin URLSearchParams: se sigue con la fecha real */ }
    // 2) fecha real en la Ciudad de México (en-CA da AAAA-MM-DD)
    try {
      return new Intl.DateTimeFormat('en-CA', {
        timeZone: 'America/Mexico_City', year: 'numeric', month: '2-digit', day: '2-digit'
      }).format(new Date());
    } catch (e) {
      return null; // sin Intl: se queda lo que pintó Liquid
    }
  }

  function faseDe(hoy) {
    if (hoy <= FIN_A) return 'a';
    if (hoy <= FIN_B) return 'b';
    return 'c';
  }

  function aplicar() {
    var hoy = hoyMexico();
    if (!hoy) return;
    var fase = faseDe(hoy);
    var franjas = document.querySelectorAll('[data-t4-franja]');
    for (var i = 0; i < franjas.length; i++) {
      var franja = franjas[i];
      franja.setAttribute('data-fase', fase);
      var promo = franja.querySelector('[data-t4-promo]');
      var tramos = franja.querySelectorAll('[data-t4-fase]');
      var hayTexto = false;
      for (var j = 0; j < tramos.length; j++) {
        var es = tramos[j].getAttribute('data-t4-fase') === fase;
        var vacio = tramos[j].textContent.replace(/\s+/g, '') === '';
        // la fase c está preparada y vacía: no se muestra aunque sea la fase vigente
        tramos[j].hidden = !(es && !vacio);
        if (es && !vacio) hayTexto = true;
      }
      if (promo) promo.hidden = !hayTexto;
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', aplicar);
  } else {
    aplicar();
  }
})();
